<template>
  <div class="bbs">
    <div class="title-warp">
      <div class="title">
        {{ bbsDetail.BBS_TITLE }}
      </div>
      <div class="regdt">
        <span>{{ dateFilter(bbsDetail.REGDT, '.') }}</span>
      </div>
    </div>
    <div class="contents">
      {{ bbsDetail.BBS_TEXT }}
    </div>
    <div class="file">
      <bbs-file :file-list="bbsDetail.BBS_FILE_LIST"/>
    </div >
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { dateFilter } from '@/utils/filter'
import { getBBSDetail } from '@/api/bbs'
import bbsFile from '@/components/BBS/BBSFile.vue'

export default {
  name: 'BBSDetail',
  components: {
    bbsFile,
  },
  props: {
    bbsNo: [Number, String],
  },
  data: () => ({
    bbsDetail: {},
  }),
  methods: {
    dateFilter,
    loadBSSDetail(){
      this.popWait();
      getBBSDetail(this.bbsNo).then((e) => {
        if(e.status === 200){
          this.bbsDetail = e.data;
        } else {
          this.bbsDetail = {};
        }
      })
      .finally(() => {
        this.stopWait();
      })
    },
    ...mapActions([
      'popWait',
      'stopWait',
    ]),
  },
  computed: {},
  mounted(){
    if(this.bbsNo !== undefined && this.bbsNo !== null){
      this.loadBSSDetail()
    }
  },
};
</script>
<style lang="scss" scoped>
  .bbs {
    display: flex;
    flex-direction: column;

    .title-warp {
      display: flex;
      justify-content: space-between;
      padding: 5px 10px;
      border-bottom: 1px solid #ccc;
      > div {
        &.title {
          font-size: 15pt;
          padding-right: 20px;
        }
        &.regdt {
          font-size: 10pt;
          vertical-align: center;
          color: #999
        }
      }
    }
    .contents {
      padding: 10px;
      flex: 1 1 auto;
      white-space: pre;
      min-height: 300px;
    }

    .file {
      padding: 10px;
      border-top: 1px solid #ccc;
    }
  }
</style>
